const isBetweenRange = (number, range) => {
  const validRange = range.split(',')
  return number.length >= validRange[0] && number.length <= validRange[1]
}

export default isBetweenRange
